/*
 * @Date: 2022-07-04 17:06:36
 * @LastEditors: chuhongguang
 */
import layout from './modules/layout'
import view from './modules/views'

export default {
  layout,
  view
}

